export const SLASH = '/';
export const OPEN = 'open';
export const COPY = 'copy';
export const SHARE = 'share';
export const LIKE = 'like';
export const EDITING = 'editing';
export const COPY_LINK = 'copy link';
export const SHARE_TEXT = 'share';
export const LIKE_TEXT = 'like';
export const PREV = 'prev';
export const NEXT = 'next';
export const SMOOTH = 'smooth';
export const REPEAT = 'repeat';
export const MULTIPLE = 'multiple';
export const TAGS = 'tags';
export const RESPONSIVE = 'responsive';
export const HIDDEN = 'hidden';
export const SCROLL = 'scroll';
export const LARGE = 'large';
export const WHITE = 'white';
export const PLUS = 'plus';
export const END = 'end';
export const TRUE = true;
export const FALSE = false;

//typography
export const H1 = 'h1';
export const H2 = 'h2';
export const H3 = 'h3';
export const H4 = 'h4';
export const H5 = 'h5';
export const H6 = 'h6';
export const SUBTITLE1 = 'subtitle1';
export const SUBTITLE2 = 'subtitle2';
export const BODY1 = 'body1';
export const BODY2 = 'body2';
export const CAPTION = 'caption';

//components
export const SPAN = 'span';
export const FORM = 'form';
export const UL = 'ul';
export const LI = 'li';
